import { render, staticRenderFns } from "./deprecated-screen.vue?vue&type=template&id=5829b67e&"
import script from "./deprecated-screen.vue?vue&type=script&lang=ts&"
export * from "./deprecated-screen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports